import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaTruck, FaTshirt, FaEye } from 'react-icons/fa'
import { FiEdit2, FiCheck } from 'react-icons/fi'

import AuthBackgroundImage from '../../../shared/components/AuthImage/AuthBackgroundImage'
import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import ImageLightbox from '../../../shared/components/ImageLightbox/ImageLightbox'
import api from '../../../utils/api'

import './ListColorImgRow.css'

import EditColorIdentity from '../EditColorIdentity'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import EditImgColor from '../imgColor/EditImgColor'
import NumberToMoney from '../../../shared/functions/NumberToMoney'


function ListColorImgRow({ dataArray, handleSelect, myPermissionEdit, myPermissionDelete, handleOnSuccess, enableSelect }) {
    const [modalEditColor, setModalEditColor] = useState(false)
    const [modalEditImg, setModalEditImg] = useState(false)
    const [modalDeleteImg, setModalDeleteImg] = useState(false)
    const [colorId, setColorId] = useState()
    const [colorName, setColorName] = useState('')
    const [colorClothId, setColorClothId] = useState(null)
    const [colorClothName, setColorClothName] = useState('')
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [lightboxItem, setLightboxItem] = useState(null)
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const editSuccess = () => {
        handleOnSuccess()
        setModalEditImg(false)
        setModalEditColor(false)
    }

    async function deleteImg(id) {
        let msgType = 'success'
        const data = await api.delete(`/color/img/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteImg(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }
    // Card "Sem tecido" (colorClothId null): apaga o cadastro da cor inteiro pra esse
    // fornecedor. Card de um tecido real: só tira a cor daquele tecido, ela continua
    // existindo nos outros tecidos.
    async function deleteColor(id) {
        let msgType = 'success'
        const data = colorClothId
            ? await api.post('/color/bulk-remove-cloth', { cloth: colorClothId, colorIds: [id] }, {
                headers: { Authorization: `Bearer ${JSON.parse(token)}` },
            }).then((response) => {
                if (response) { handleOnSuccess(); setModalDeleteItem(false) }
                return response.data
            }).catch((err) => { msgType = 'error'; return err.response.data })
            : await api.delete(`/color/delete/${id}`, {
                headers: { Authorization: `Bearer ${JSON.parse(token)}` },
            }).then((response) => {
                if (response) { handleOnSuccess(); setModalDeleteItem(false) }
                return response.data
            }).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
    }

    const handleOnEditImg = (item) => {
        setColorId(item._id)
        setModalEditImg(true)
    }

    const handleOnSelect = (item) => {
        if (enableSelect) {
            handleSelect(item)
        }
    }

    const listArray = () => {
        if (dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div
                    key={item._cardKey || item._id}
                    className={`color-card ${enableSelect ? 'color-card-selectable' : ''}`}
                    onClick={() => handleOnSelect(item)}
                >
                    <div
                        className="color-card-image-wrap"
                        onClick={(e) => { if (!enableSelect && item.image) { e.stopPropagation(); setLightboxItem(item) } }}
                    >
                        <AuthBackgroundImage className="color-card-image shd-bgimg-cover" src={item.image ? `/images/color/${item.image}` : null}>
                            {!enableSelect && (
                                <div className="color-card-image-actions">
                                    {myPermissionEdit &&
                                        <div className="color-card-image-bt color-card-image-bt-edit" title="Editar imagem" onClick={(e) => { e.stopPropagation(); handleOnEditImg(item) }}>
                                            <FiEdit2 size={13} />
                                        </div>
                                    }
                                    {myPermissionDelete &&
                                        <div className="color-card-image-bt color-card-image-bt-delete" title="Apagar imagem" onClick={(e) => { e.stopPropagation(); setModalDeleteImg(true); setColorId(item._id) }}>
                                            <FaTrashAlt size={12} />
                                        </div>
                                    }
                                </div>
                            )}
                        </AuthBackgroundImage>
                        {!enableSelect && item.image && (
                            <div className="color-card-image-zoom-hint">
                                <FaEye size={20} />
                            </div>
                        )}
                    </div>

                    <div className="color-card-body">
                        <div className="color-card-header">
                            <span className="color-card-name" title={item.name}>{item.name}</span>
                            {item.colorType?.name && (
                                <span className="color-card-type-badge">{item.colorType.name}</span>
                            )}
                        </div>

                        <div className="color-card-meta">
                            {item.provider?.label && (
                                <span className="color-card-meta-item"><FaTruck size={11} />{item.provider.label}</span>
                            )}
                            <span className="color-card-meta-item"><FaTshirt size={11} />{item.cloth?.name || 'Sem tecido'}</span>
                            {item.ref && <span className="color-card-ref">ref: {item.ref}</span>}
                        </div>

                        {item.costs?.length > 0 && (
                            <div className="color-card-costs">
                                <div className="color-card-cost-group">
                                    {item.costs.map((i) => (
                                        <span className="color-card-cost-item" key={i._id}>
                                            {i.description && `${i.description} — `}
                                            {i.minUnit}–{i.maxUnit} un: R$ {NumberToMoney(i.cost)}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {!enableSelect && (
                            <div className="color-card-footer">
                                {myPermissionEdit &&
                                    <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={(e) => { e.stopPropagation(); setColorId(item._id); setColorClothId(item.cloth?._id || null); setColorClothName(item.cloth?.name || ''); setModalEditColor(true) }} />
                                }
                                {myPermissionDelete &&
                                    <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setColorId(item._id); setColorName(item.name); setColorClothId(item.cloth?._id || null); setColorClothName(item.cloth?.name || '') }} />
                                }
                            </div>
                        )}
                    </div>

                    {enableSelect && (
                        <div className="color-card-checkbox">
                            <FiCheck size={13} />
                        </div>
                    )}
                </div>
            ))
        }
    }
    return (

        <div>
            <div className='color-card-grid'>
                {listArray()}
            </div>

            <Modal
                modalStatus={modalEditColor}
                changeStatus={setModalEditColor}
                w={45}
                content={
                    colorId && <EditColorIdentity id={colorId} clothId={colorClothId} clothName={colorClothName} handleOnSuccess={editSuccess} btCancelAction={() => setModalEditColor(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteColor(colorId)}
                message={colorClothId
                    ? `Deseja realmente remover essa cor do tecido "${colorClothName}"? A cor continua existindo nos outros tecidos e nesse fornecedor.`
                    : 'Deseja realmente excluir essa cor desse fornecedor? Isso apaga só o cadastro dela (ref, custo, imagem) para esse fornecedor — o item no catálogo de cores não é afetado e pode ser associado de novo depois.'}
                itemName={colorName}
            />

            {/* image */}
            <Modal
                modalStatus={modalEditImg}
                changeStatus={setModalEditImg}
                w={40}
                content={
                    <EditImgColor id={colorId} handleSubmit={() => { }} handleOnSuccess={editSuccess} btCancelAction={() => setModalEditImg(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteImg}
                changeStatus={setModalDeleteImg}
                onConfirm={() => deleteImg(colorId)}
                title="Confirmar exclusão"
                message="Deseja realmente excluir essa imagem?"
            />

            <ImageLightbox
                src={lightboxItem ? `/images/color/${lightboxItem.image}` : null}
                alt={lightboxItem?.name}
                caption={lightboxItem?.name}
                onClose={() => setLightboxItem(null)}
            />

        </div>
    )
}

export default ListColorImgRow
